import React, { useEffect } from 'react';
import { getDealerKvps } from 'src/bff';
import { TriggerProps, useFaContent } from 'src/feature-app';
import { FormDataFields } from 'src/types';
import { transformMillage } from '../helpers';
import { ProspectsPosventaForm } from './ProspectsPosventaForm';

export function ProspectsCalculadoraEmbedded({ setSelectedJourney }: TriggerProps) {
	const faContent = useFaContent();
	const renderForm = (fields: FormDataFields) => {
		setSelectedJourney(
			<ProspectsPosventaForm
				updatedFormData={{
					fields,
				}}
			/>,
			true,
		);
	};
	useEffect(() => {
		const fields = {
			motivo: 'MANTENIMIENTO',
			formName: 'prospect-posventa-calculadora',
			matricula: faContent?.vehicle[0]?.license,
			kilometros: transformMillage(faContent?.vehicle[0]?.localKM),
			anoMatriculacion: faContent?.vehicle[0]?.licenseDate,
			modelo: faContent?.vehicle[0]?.familyModelDesc,
			budget: { pvp: faContent?.quotePvp, operations: [...faContent?.quoteOperations] },
			deepLink: faContent?.deepLink,
		};
		const kvps = faContent?.dealer;

		getDealerKvps(kvps)
			.then((dealer) => {
				renderForm({ ...fields, dealer });
			})
			.catch((err) => {
				console.error(err);
				renderForm({ ...fields, dealer: {} }); // Hay que ver que hacer en estos casos.
			});
	}, []);

	return <></>;
}
